import styled from 'styled-components';

export const BodySection = styled.div`
  height:${(props) => (props.bodyHeight ? `calc(${props.bodyHeight} - 21px)` : '200px')};
  overflow-y: scroll;
  margin-bottom: 10px;
  `;

export const CollapsibleListWrapper = styled.div`
  margin-bottom: 3px;
`;

export const Container = styled.div`
  margin-bottom: 3px;
`;
